<!-- Grab the toolbar if it exists and place it at the top -->
<ng-content select="glxy-page-toolbar"></ng-content>

<ng-container *ngIf="isLoading">
  <div class="loading-bar">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</ng-container>

<div class="glxy-page-main-content" cdkScrollable (scroll)="onPageScroll($event)">
  <ng-content></ng-content>
</div>
